export class CreatedEventSettings {
  public email: string;
  public end: string;
  public end_date: string;
  public group_id: number;
  public room_id: number;
  public start: string;
  public start_date: string;
  public summary: string;
  public repeat_rule: string;
  public created_id_user: number;
}



// WEBPACK FOOTER //
// /app/src/app/models/created-event-settings.ts